import { merge } from 'lodash';

const defaultDateColumnParams = {
  filterParams: {
    inRangeInclusive: true,
    // provide comparator function
    comparator: (filterLocalDateAtMidnight, cellValue) => {
      const dateAsString = cellValue;
      if (dateAsString == null) return 0;

      // Dates are stored as yyyy/mm/dd
      // We create a Date object for comparison against the filter date
      const dateParseResult = /^(\d+)-(\d+)-(\d+)/.exec(dateAsString);
      if (!dateParseResult) return 0;

      const [, year, month, day] = dateParseResult;

      const adjustedMonth = month - 1;
      const cellDate = new Date(year, adjustedMonth, day);

      // Now that both parameters are Date objects, we can compare
      if (cellDate < filterLocalDateAtMidnight) return -1;
      if (cellDate > filterLocalDateAtMidnight) return 1;
      return 0;
    },
  },
};
/**
 * Base class for AgGrid Column Definition creators.
 * Defines methods for creating column definitions.
 */
export class BaseColDefs {
  /**
   * Ag-Grid column definition factories.
   *
   * This is used for avoiding repetitions such as { filter: 'xxxx' } across multiple col defs.
   * Furthermore, the semantic meaning becomes more obvious and enforces that the same type of data
   * should have the same type setup
   */
  static colDefFactory(filter, defaultParams = {}) {
    return (params) => merge({ ...defaultParams }, { ...params, filter });
  }

  static configurableColGroupIdToColDefFactoryField = {
    licenseCompliance: 'licenseComplianceColGroup',
    strLicenseInfo: 'strLicenseInfoColGroup',
  };

  multiColumn = BaseColDefs.colDefFactory('agMultiColumnFilter');

  numberColumn = BaseColDefs.colDefFactory('agNumberColumnFilter');

  textColumn = BaseColDefs.colDefFactory('agTextColumnFilter');

  setColumn = BaseColDefs.colDefFactory('agSetColumnFilter');

  multiFilterColumn = BaseColDefs.colDefFactory('agMultiColumnFilter');

  dateColumn = BaseColDefs.colDefFactory(
    'agDateColumnFilter',
    defaultDateColumnParams
  );

  noFiltersColumn = BaseColDefs.colDefFactory(null);
}
